import * as React from 'react'

import { Image } from '../image/Image'
import { AvatarInitial } from './AvatarInitial'

export const AvatarImage = ({ src, alt }: { src: string; alt: string }) => {
  if (!src) {
    return <AvatarInitial />
  }

  return <Image className="size-full object-cover" src={src} alt={alt} />
}
